import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api';
import { Star, Sparkle } from '@phosphor-icons/react';

const fmtAgo = (iso) => {
  if (!iso) return '';
  const d = new Date(iso); const m = (Date.now() - d.getTime()) / 60000;
  if (m < 60) return `${Math.floor(m)}m ago`;
  if (m < 1440) return `${Math.floor(m / 60)}h ago`;
  return `${Math.floor(m / 1440)}d ago`;
};

const TourBubbles = () => {
  const [tours, setTours] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/tour-bubbles/active').then(({ data }) => {
      setTours(data.tours || []);
    }).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-10 pb-24">
      <div className="mb-8">
        <div className="text-[10px] uppercase tracking-widest text-bx-gold">layer 4 · drifters from the real world</div>
        <h1 className="font-display text-4xl sm:text-5xl font-black mt-1">Tour Bubbles</h1>
        <p className="text-white/60 mt-2 text-sm max-w-2xl">
          Real artists, real teams, real festivals send their Bubbles into our world.
          They drift through the network carrying backstage clips, exclusive moments,
          and sometimes — a ticket. You won't see them in a catalog. You'll catch
          one only by chance.
        </p>
      </div>

      {loading ? (
        <div className="text-white/60">listening…</div>
      ) : tours.length === 0 ? (
        <div className="glass rounded-3xl p-10 text-center">
          <div className="mx-auto h-16 w-16 rounded-full bg-bx-gold/10 grid place-items-center mb-4">
            <Star size={28} className="text-bx-gold" />
          </div>
          <div className="font-display text-xl font-bold">No tours active right now.</div>
          <p className="text-white/65 text-sm mt-2 max-w-md mx-auto">
            When a verified celebrity, team, or venue launches their Tour Bubble,
            it'll start drifting through the network. Keep your bubble out there.
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {tours.map((t) => (
            <div key={t.id} data-testid={`tour-${t.id}`} className="glass rounded-2xl p-5">
              {t.cover_image_b64 && (
                <img alt="" src={`data:image/png;base64,${t.cover_image_b64}`}
                  className="w-full h-32 object-cover rounded-xl mb-3" />
              )}
              <div className="text-[10px] uppercase tracking-widest text-bx-gold">{t.tier}</div>
              <div className="font-display font-bold text-lg mt-1">{t.name}</div>
              {t.tagline && <div className="text-xs text-white/60 mt-1 italic">"{t.tagline}"</div>}
              <div className="flex items-center justify-between mt-3 text-xs">
                <span className="text-bx-cyan">{t.encountered} encountered</span>
                <span className="text-white/60">prize: {t.prize_kind || '—'}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TourBubbles;
